import React from 'react';
import PropTypes from 'prop-types';
import TOCFilters from '../tableOfContents/TOCFilters';
import { t } from '../../services/i18nService';
import styles from './header.scss';

class TocSubHeader extends React.Component {
    static propTypes = {
        assessment: PropTypes.object.isRequired,
    };

    componentDidMount() {
        this.h1.focus();
    }

    render() {
        const { assessment } = this.props;

        return (
            <div className={styles.tocHeaderWrapper}>
                <div className={styles.statusSection}>
                    <div className={styles.subHeaderTitle}>
                        <h1 tabIndex="-1" ref={(h1) => { this.h1 = h1; }}>{assessment.title}</h1>
                    </div>
                </div>
                <h2 className="sr-only">{t('testOverview.tocHeader_sr_only')}</h2>
                <TOCFilters {...this.props} />
            </div>
        );
    }
}

export default TocSubHeader;
